import { LeadJourneySquare1 } from "../container";
import styles from "./leadjourneywrapper.module.css";
import ReminderComponent from "../ReminderComponent";
import InteractionComponent from "../InteractionComponent";
import LeadJourneyDetails from "./LeadJourneyDetails";
import LeadJourneySquare from "./LeadJourneySquare";
import { useGetLeadOwner } from "@/api/auth/useGetLeadOwner";
import { useGetLeadDetailsSquare } from "@/api/lead/useGetLeadDetailsSquare";

const LeadJourneyContainerWrapper = ({ leadID }) => {

  const leadOwner = useGetLeadOwner({leadID: leadID});
  const {leadDetails, refetch} = useGetLeadDetailsSquare({leadId: leadID});

  return (
    <div className={styles.wrapper}>
      <LeadJourneySquare leadDetails = {leadDetails} leadOwner = {leadOwner} onRefetch = {refetch}/>
      <LeadJourneyDetails leadOwner={leadOwner} leadID={leadID} />
      <div className="flex justify-between w-full mr-5">
        <ReminderComponent leadID={leadID} owner={leadOwner}/>
        <InteractionComponent leadID={leadID} owner={leadOwner}/>
      </div>
    </div>
  );
};

export default LeadJourneyContainerWrapper;
